/**
 * Android geri tuşu: önce kayıtlı modal yakalayıcı, sonra Radix dialog Escape, sonra history / çıkış.
 * Yalnızca Capacitor native Android'de dinlenir; web'de no-op.
 */
import { App } from '@capacitor/app';
import { Capacitor } from '@capacitor/core';

/** @returns {boolean|void} true = olay tüketildi */
let interceptor = null;

export function setAndroidBackInterceptor(fn) {
  interceptor = typeof fn === 'function' ? fn : null;
}

export function clearAndroidBackInterceptor() {
  interceptor = null;
}

function tryDismissRadixOverlay() {
  const open = document.querySelector(
    '[data-state="open"][role="dialog"], [data-state="open"][role="alertdialog"]'
  );
  if (!open) return false;
  document.dispatchEvent(new KeyboardEvent('keydown', { key: 'Escape', bubbles: true, cancelable: true }));
  return true;
}

let listenerHandle = null;

export async function initCapacitorAndroidBackButton() {
  if (!Capacitor.isNativePlatform() || Capacitor.getPlatform() !== 'android') {
    return () => {};
  }
  listenerHandle = await App.addListener('backButton', async ({ canGoBack }) => {
    if (typeof interceptor === 'function') {
      try {
        if (interceptor() === true) return;
      } catch {
        /* */
      }
    }
    if (tryDismissRadixOverlay()) return;
    if (canGoBack) {
      window.history.back();
      return;
    }
    await App.exitApp();
  });
  const remove = () => {
    listenerHandle?.remove();
    listenerHandle = null;
  };
  return remove;
}
